import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { alertSelector } from "../../utils/selectors";

const Alert: React.FC<any> = ({ alerts }) => {
  useEffect(() => {
    if (alerts && alerts.length > 0) {
      alerts.forEach((alert: any) => {
        toast(alert.msg, {
          type: alert.alertType === "danger" ? "error" : alert.alertType,
          toastId: alert.id,
        });
      });
    }
  }, [alerts]);

  return (
    <ToastContainer />
  );
};

const mapStateToProps = (state: any) => ({
  alerts: alertSelector(state),
});

export default connect(mapStateToProps)(Alert);
